module.exports = __webpack_public_path__ + "static/media/ticket_campaign_preview_details_content_pic.d01b7fa7.svg";